module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Fc-Gc-Hc-Ia.a6993e22.png";